<template>
  <div class="card w-100 h-100">
    <div class="card-body">
      <table class="table">
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Meta</th>
            <th>Realizado</th>
            <th>Detalhamento</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="font-weight-normal">Status de pagamento de mensalidade</td>
            <td class="font-weight-light text-secondary">20%</td>
            <td class="font-weight-light text-secondary">{{ getPaymentPercent }}</td>
            <td class="font-weight-light text-secondary text-capitalize"> {{ getPaymentValue }} </td>
          </tr>
          <tr>
            <td class="font-weight-normal">North Star</td>
            <td class="font-weight-light text-secondary">30%</td>
            <td class="font-weight-light text-secondary">{{ getNorthStarPercent }}</td>
            <td class="font-weight-light text-secondary">{{ getNorthStarStatus }} <a href="#"
                @click="$emit('changeToNorthStar')"><u>Ver detalhes</u></a></td>
          </tr>
          <tr>
            <td class="font-weight-normal">NPS</td>
            <td class="font-weight-light text-secondary">25%</td>
            <td class="font-weight-light text-secondary">{{ getNPSPercent }}</td>
            <td class="font-weight-light text-secondary">{{ getNPSStatus }}</td>
          </tr>
          <tr>
            <td class="font-weight-normal">CSAT</td>
            <td class="font-weight-light text-secondary">25%</td>
            <td class="font-weight-light text-secondary">{{ getCSATPercent }}</td>
            <td class="font-weight-light text-secondary">Nota {{ healthScoreData.csat }}</td>
          </tr>
          <tr>
            <td>TOTAL</td>
            <td>100%</td>
            <td><strong :class="getHealthScoreColor">{{ getScorePayment }}%</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    healthScoreData: {
      type: Object,
    },
    proposalData: {
      type: Object,
    }
  },
  computed: {
    getPaymentPercent(){
      return this.proposalData?.subscription?.sale_item?.name ? '20%' : '0%'
    },
    getPaymentValue(){
      return this.proposalData?.subscription?.sale_item?.name ? this.proposalData.subscription.sale_item.name : 'Sem informações'
    },
    getScorePayment(){
      return this.proposalData?.subscription?.sale_item?.name ? this.healthScoreData.score: this.healthScoreData.score - 20
    },
    getNorthStarPercent(){
      return this.healthScoreData?.lastNorthStar ? '30%' : '0%'
    },
    getNorthStarStatus(){
      return this.healthScoreData?.lastNorthStar ? 'Sim' : 'Não'
    },
    getNPSPercent(){
      if(this.healthScoreData?.nps){
        return this.healthScoreData?.nps > 8 ? '15%' : '0%'
      }
      else {
        return '15%'
      }
    },
    getNPSStatus(){
      if(this.healthScoreData?.nps < 7){
        return 'Detrator'
      }
      else if(this.healthScoreData?.nps > 6 && this.healthScoreData?.nps < 9){
        return 'Neutro'
      }
      else {
        return 'Promotor'
      }
    },
    getCSATPercent(){
      if(this.healthScoreData?.csat){
        return this.healthScoreData?.csat > 8 ? '15%' : '0%'
      }
      else {
        return '15%'
      }
    },
    getHealthScoreColor(){
      if(this.getScorePayment >= 80){
        return 'text-success'
      }
      else if(this.getScorePayment >= 50 && this.getScorePayment < 80){
        return 'text-warning'
      }
      else {
        return 'text-danger'
     }
    }
  },
}
</script>
<style></style>